// extracted by mini-css-extract-plugin
module.exports = {"results":"SearchBoards_results__1hiyz","resultBoard":"SearchBoards_resultBoard__Q8aIH"};